export default __webpack_public_path__ + "static/media/edit.881f0cb1.png";